// Справочник - для какой цели отправлен смс токен: 0 = PhoneConfirmation, 1 = PhoneChanging, 2 = PasswordReset

export const phoneTokenPurposeTypes = {
    forPhoneConfirmation : 0,
    forPhoneChanging : 1,
    forPasswordReset : 2,
};
